import { EPUB_SETTING } from '@app/config/const'
import { ensureReaderFont, preloadTypekit } from '@modules/epubViewer/fontLoader'
import initReaderSetting from '@modules/epubViewer/utils/setting'
import AppProvider from '@provider/AppProvider'
import StorageServices from '@services/local.storage'
import store, { persistor } from '@store/index'
import { ConfigProvider } from 'antd'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'

import App from './App'

// Start the saved reader font while the application shell is loading. EPUB
// iframes still register it independently, but reuse these downloaded bytes.
const initialReaderSetting = StorageServices.getData(
  EPUB_SETTING,
  initReaderSetting
)
void preloadTypekit()
void ensureReaderFont(document, initialReaderSetting.fontFamily)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      <Router>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#9BB73F',
              fontFamily: 'Meirio, sans-serif'
            }
          }}
        >
          <AppProvider>
            <App />
          </AppProvider>
        </ConfigProvider>
      </Router>
    </PersistGate>
  </Provider>
)
